import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { get, useFormContext } from 'react-hook-form';

export function ConstantValueForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext();

  const daysFieldPath = fieldPath('days');
  const daysFieldError = get(form.formState.errors, daysFieldPath);

  return (
    <FormControl isInvalid={!!daysFieldError} isRequired>
      <FormLabel htmlFor={daysFieldPath}>Days:</FormLabel>

      <Input
        {...form.register(daysFieldPath)}
        id={daysFieldPath}
        type="number"
        inputMode="numeric"
        min={0}
      />

      <ErrorMessage
        name={daysFieldPath}
        render={({ message }) => <FormErrorMessage>{message}</FormErrorMessage>}
      />
    </FormControl>
  );
}
